var exports = {
  "kL": "FriendSelector.module__container___SjlYRk",
  "hJ": "FriendSelector.module__searchField___SjlYRk",
  "lA": "FriendSelector.module__searchFieldInner___SjlYRk",
  "t$": "FriendSelector.module__selectedPill___SjlYRk",
  "DT": "FriendSelector.module__removeButton___SjlYRk",
  "qc": "FriendSelector.module__searchIcon___SjlYRk",
  "D3": "FriendSelector.module__searchIconFocused___SjlYRk",
  "Rt": "FriendSelector.module__searchInput___SjlYRk",
  "XG": "FriendSelector.module__scroller___SjlYRk",
  "yY": "FriendSelector.module__scrollerNoSearch___SjlYRk",
  "p$": "FriendSelector.module__emptyState___SjlYRk",
  "q6": "FriendSelector.module__emptyStateText___SjlYRk",
  "_s": "FriendSelector.module__groupsContainer___SjlYRk",
  "cp": "FriendSelector.module__groupLetter___SjlYRk",
  "QS": "FriendSelector.module__friendsList___SjlYRk",
  "jZ": "FriendSelector.module__friendButton___SjlYRk",
  "An": "FriendSelector.module__friendButtonSelected___SjlYRk",
  "FI": "FriendSelector.module__friendButtonDisabled___SjlYRk",
  "Hb": "FriendSelector.module__friendInfo___SjlYRk",
  "G3": "FriendSelector.module__friendName___SjlYRk",
  "HI": "FriendSelector.module__checkboxContainer___SjlYRk",
  "Yz": "FriendSelector.module__removeIcon___SjlYRk",
};

module.exports = exports;
